(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v2-product-bundle-signup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("a").forEach(function (link) {
      if (
        !link.href.includes("/pages/check-availability")
        && !link.href.includes("/pages/subscription-flow")
      ) {
        // It is not a Get Started link
        return;
      }
      link.href = "#";
      link.dataset.bsToggle = "modal";
      link.dataset.bsTarget = "#check-availability-modal";
      link.textContent = "Order Now";
    });
  });

  } catch(e) { console.error(e); }
})();
})();
